import { useEffect } from "react";
import {
  setRulesData,
  setRulesFilters,
  setRulesPage,
  setRulesSort,
  setRulesTake,
  setRulesTotalCount,
  useSelectFiltersRules,
  useSelectPageRules,
  useSelectSortRules,
  useSelectTakeRules,
  useSelectTotalCountRules,
} from "../../../../redux/features/rules/rulesSlice";
import { useDispatch } from "react-redux";
import { errorMsg, SORT_DIRECTION } from "../../../../utils/vars";
import { useMutation, useQuery } from "@tanstack/react-query";
import { deleteRule, getAllPaginated1 } from "../../../../services/rules";
import { toast } from "react-toastify";

const useRulesTable = () => {
  const dispatch = useDispatch();
  const sort = useSelectSortRules();
  const page = useSelectPageRules();
  const take = useSelectTakeRules();
  const totalCount = useSelectTotalCountRules();
  const filters = useSelectFiltersRules();

  const {
    data,
    refetch: refetchRules,
    error: errorRulesFetch,
    isFetching: isFetchingRules,
  } = useQuery({
    queryKey: ["get-rules", getQueryParams()],
    queryFn: () => getAllPaginated1(getQueryParams()),
    retry: 1,
    refetchOnWindowFocus: false,
  });

  const deleteRuleMutation = useMutation({
    mutationFn: deleteRule,
    onSuccess: async () => {
      await refetchRules();
      toast.success("Successfully deleted rule");
    },
    onError: (err) => {
      toast.error(err.response?.data?.message || errorMsg);
    },
  });

  useEffect(() => {
    if (data) {
      dispatch(setRulesData(data?.data));
      dispatch(setRulesTotalCount(data?.totalCount));
    }
  }, [data, dispatch]);

  const toggleSort = (type) => {
    const currentType = sort.type;
    const currentDirection = sort.direction;

    if (type === currentType) {
      const direction =
        SORT_DIRECTION.DESC === currentDirection
          ? SORT_DIRECTION.ASC
          : SORT_DIRECTION.DESC;
      dispatch(setRulesSort({ direction, type }));
    } else {
      dispatch(setRulesSort({ direction: SORT_DIRECTION.DESC, type }));
    }

    dispatch(setRulesPage(0));
  };

  const handleFilterChange = async (key, filter) => {
    if (key !== "DATE") {
      dispatch(setRulesFilters({ [key]: filter }));
    } else {
      dispatch(setRulesFilters({ ...filter }));
    }

    dispatch(setRulesPage(0));
  };

  function getQueryParams() {
    const searchParams = new URLSearchParams();

    searchParams.append("page", page);
    searchParams.append("size", take);
    searchParams.append("direction", sort.direction);
    searchParams.append("type", sort.type);
    searchParams.append("rType", "BASIC");

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== "" && value !== null && value !== undefined) {
        searchParams.append(key, value);
      }
    });

    return searchParams.toString();
  }

  const handlePageChange = (newPage) => {
    dispatch(setRulesPage(newPage - 1));
  };

  const handleTakeChange = (newSize) => {
    dispatch(setRulesTake(newSize));
  };

  const deleteHandler = async (id) => {
    deleteRuleMutation.mutate(id);
  };

  return {
    handleFilterChange,
    toggleSort,
    deleteHandler,
    handlePageChange,
    handleTakeChange,
    isFetchingRules,
    errorRulesFetch,
    sort,
    filters,
    take,
    page,
    totalCount,
  };
};
export default useRulesTable;
